export * from "./load-component.module";
export * from "./load-component.service";
export * from "./load-component.directive";
